import React from 'react'
import Icon from '../Icon'

/**
* Diagonal Arrow icon.
*/
function DiagonalArrowIcon(props) {
  const { ...rest } = props

  return (
    <Icon
      icon="diagonal-arrow"
      aria-hidden
      role="presentation"
      {...rest}
    >
      <g><path d="M9 5v2h6.59l-11.59 11.59 1.41 1.41 11.59-11.59v6.59h2v-10z" /></g>
    </Icon>
  )
}

export default DiagonalArrowIcon
